import React from "react";
import Tr from "./Tr"; // Importing the row component for the table

export default function Table({
  data, // Array of data to be displayed in the table
  onEdit, // Function to handle editing an item
  onDelete, // Function to handle deleting an item
  isAllowedToEditOrDelete, // Boolean to control edit/delete permissions
}) {
  return (
    <>
      <div className="form-container">
        <table className="table">
          <thead>
            <tr>
              <th className="col-numeric-date">Order</th> {/* Column for item order */}
              <th className="col-numeric-date">Name</th> {/* Column for item name */}
              <th className="col-numeric-date">Base Image</th> {/* Column for pattern */}
              <th className="col-options">Options</th> {/* Column for action options */}
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? ( // Check if there's any data to display
              <tr>
                <td colSpan={4}>No data found....</td> {/* Message for empty state */}
              </tr>
            ) : (
              data.map((d, index) => ( // Map through data to create rows
                <Tr
                  key={index} // Unique key for each row
                  order={index + 1} // Pass the order (1-based index)
                  id={d.pattern_id} // Unique ID for the pattern
                  pattern_name={d.pattern_name} // Name of the pattern
                  thumbnail_url={d.thumbnail_url} // URL for the pattern thumbnail
                  thumbnail_url_preview={d.thumbnail_url_preview}
                  art_pack_id={d.art_pack_id} // ID for the associated art pack
                  onEdit={onEdit} // Edit handler function
                  onDelete={onDelete} // Delete handler function
                  isAllowedToEditOrDelete={isAllowedToEditOrDelete} // Permission flag
                />
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
